import * as types from './mutation-types';

export const setHelpTopics = ({commit}, helpTopics) => {
  commit(types.SET_HELP_TOPICS, helpTopics);
}

export const setIsViewingHelp = ({commit}, isViewingHelp) => {
  commit(types.SET_IS_VIEWING_HELP, isViewingHelp);
}

export const setTempHelpTopicKey = ({commit}, topicKey) => {
  commit(types.SET_TEMP_HELP_TOPIC_KEY, topicKey);
}

export const setComponentHelpTopicKey = ({commit}, topicKey) => {
  commit(types.SET_COMPONENT_HELP_TOPIC_KEY, topicKey);
}

export const setRouteHelpTopicKey = ({commit}, topicKey) => {
  commit(types.SET_ROUTE_HELP_TOPIC_KEY, topicKey);
}

export const setDefaultHelpTopicKey = ({commit}, topicKey) => {
  commit(types.SET_DEFAULT_HELP_TOPIC_KEY, topicKey);
}
